import React from 'react';
import { ProtectedRoute } from '../ProtectedRoute';
import { Navbar } from '../Navbar';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout component that wraps pages with authentication protection and navbar.
 */
export const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  return (
    <ProtectedRoute>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1">
          {children}
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default ProtectedLayout;
